import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PublicLayout from "../../components/layout/PublicLayout";
import heroImage from "../../assets/images/unzippd-logo.png";
import {
  FAQ_SECTIONS,
  FAQ_SECTIONS_ITEMS_QUESTIONS,
  formatFaqLabel,
  getFaqSectionElementId,
} from "../../constants/faqSections";

const FaqPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const sectionEl = document.querySelector(location.hash);
    if (!sectionEl) return;

    const headerOffset = 88;
    const elementTop =
      sectionEl.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({
      top: Math.max(elementTop, 0),
      behavior: "smooth",
    });
  }, [location.hash]);

  return (
    <PublicLayout>
      <div className="bg-[#1A1A1A] text-white pt-[72px] overflow-x-hidden">
        <section className="bg-[rgb(77_148_255/var(--tw-bg-opacity))]">
          <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8 py-10 sm:py-24">
            <div className="relative grid grid-cols-1 md:grid-cols-[1fr_auto] gap-8 items-start">
              <div className="text-left text-white md:max-w-[56%] lg:max-w-[60%]">
                <p className="m-0 text-base font-semibold uppercase tracking-wide text-white/90">
                  Support
                </p>
                <h1 className="mt-4 mb-4 text-4xl sm:text-5xl font-bold leading-tight">
                  Frequently asked questions
                </h1>
                <p className="m-0 max-w-3xl text-white/95 text-lg sm:text-xl">
                  Everything you need to know about unzippd
                </p>
              </div>
              <div className="pointer-events-none absolute right-0 top-0 hidden md:block">
                <img
                  src={heroImage}
                  alt="Unzippd support"
                  className="h-28 w-28 sm:h-36 sm:w-36 object-contain"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="bg-[#1A1A1A] text-white">
          <div className="mx-auto w-full max-w-7xl min-w-0 box-border">
            {FAQ_SECTIONS.map((sectionTitle, sectionIdx) => (
              <section
                key={sectionTitle}
                id={getFaqSectionElementId(sectionTitle)}
                className={`scroll-mt-24 px-4 sm:px-6 lg:px-8 py-10 sm:py-14 ${
                  sectionIdx % 2 === 0 ? "bg-[#202020]" : "bg-[#161616]"
                }`}
              >
                <h6 className="m-0 text-xl sm:text-md font-bold text-[#0E63F4]">
                  {sectionTitle}
                </h6>
                <div className="w-full max-w-full space-y-0 overflow-hidden">
                  {(FAQ_SECTIONS_ITEMS_QUESTIONS[sectionTitle] ?? []).map(
                    (item) => (
                      <article
                        key={`${sectionTitle}-${item.question}`}
                        className="box-border w-full max-w-full min-h-[220px] border-b border-[#333333] py-6 sm:py-16"
                      >
                        <div className="flex min-w-0 flex-col md:flex-row gap-4 md:gap-12 md:items-start">
                          <div className="min-w-0 flex-1">
                            <h3 className="m-0 text-xl sm:text-2xl font-semibold text-white">
                              {item.question}
                            </h3>
                            <p className="mt-2 mb-0 text-sm sm:text-base text-gray-300">
                              {item.answer}
                            </p>
                            {(item.labels ?? []).length > 0 && (
                              <div className="mt-8 flex flex-wrap gap-2">
                                {(item.labels ?? []).map((label, labelIdx) => (
                                  <span
                                    key={`${item.question}-label-${labelIdx}`}
                                    className="inline-flex rounded-full bg-[rgb(77_148_255/var(--tw-bg-opacity))] px-3.5 py-1.5 text-sm font-semibold text-white"
                                  >
                                    {formatFaqLabel(label)}
                                  </span>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </article>
                    )
                  )}
                </div>
              </section>
            ))}
          </div>
        </section>
      </div>
    </PublicLayout>
  );
};

export default FaqPage;
